import { ILoggingService } from './loggingService';
import { errorIsCancel, errorIsSessionExpired } from '../api/apiBase';
import { IConnectionMonitorService, IHeartbeatService } from './connectionMonitorService';
import { flow } from 'mobx';
import { ISportsBettingSessionCommonApi } from '../api/apiSession';

export interface IDateTimeService {
    now(): Date;
    remainingSeconds: (date: Date) => number;
}

export interface IDateTimeServiceWithIHeartbeatService extends IHeartbeatService, IDateTimeService {
}

/**
 * Checks server time and it's also heartbeat check and token validity check
 */
export function createDateTimeWithHeartbeatServiceMts(
    serverOffsetMin: number,
    sessionApi: ISportsBettingSessionCommonApi,
    loggingService: ILoggingService,
    connectionMonitorService: IConnectionMonitorService
): IDateTimeServiceWithIHeartbeatService {
    let baseTimeDifference = getBaseTimeDifference();
    let timeDifference = baseTimeDifference;
    let lastServerResultTs = -1;
    let lastServerAttemptTs = -1;
    let processingUpdateServerTime = false;

    function getBaseTimeDifference() {
        var localTime = new Date();
        return (serverOffsetMin + localTime.getTimezoneOffset()) * 60000;
    }

    const updateServerTimeAsync: (isForcedFromUI: boolean) => Promise<void> = flow(function* (isForcedFromUI: boolean) {
        if (!isForcedFromUI && processingUpdateServerTime) {
            throw new Error("Unexpectedly already processing");
        }

        processingUpdateServerTime = true;
        try {
            //this may also work as 404 detection
            lastServerAttemptTs = new Date().getTime();

            let value: Date = yield sessionApi.getServerTimeAsyncForMts(true); //!forces to check tokens in api since other calls to get events does not do this (just e.g. operation with bet - modifyOdds ...)

            processingUpdateServerTime = false;
            var currentTs = new Date().getTime();
            timeDifference = value.getTime() + baseTimeDifference - currentTs;
            lastServerResultTs = currentTs;
            connectionMonitorService.heartbeatSuccess();
        }
        catch (e) {
            if (errorIsCancel(e)) {
                throw e;
            }
            if (errorIsSessionExpired(e)) {
                throw e; //expected to be reloaded
            }
            processingUpdateServerTime = false;
            loggingService.error("Server time hasn't been updated");
            connectionMonitorService.heartbeatError();
            // in case of problem previous value remains
            throw e;
        }
    });

    function refreshCurrentTime() {
        //return;  //  disabled for debugging
        window.setTimeout(function () {
            var ts = new Date().getTime();
            if (ts - lastServerResultTs > 30000 && ts - lastServerAttemptTs > 19000) {
                if (!processingUpdateServerTime) {
                    updateServerTimeAsync(false); // expected async!
                }
            }
            refreshCurrentTime();
        }, 8000);
    }

    const forceCheckHeartbeatAsync: () => Promise<void> = () => {
        return updateServerTimeAsync(true);
    }

    refreshCurrentTime();
    const now = () => {
        return new Date(new Date().getTime() + timeDifference);
    };
    return {
        now,
        remainingSeconds: (dateTime: Date) => {
            return Math.round((dateTime.getTime() - now().getTime()) / 1000);
        },
        forceCheckAsync: forceCheckHeartbeatAsync
    };
}
